import React from "react";
import "./Loading.css";

const LoadingPoints = ({ color = "#000000", tamanho = "10px" }) => {
  return (
    <div className="loading-container">
      <span className="dot" style={{ backgroundColor: color, width: tamanho, height: tamanho }}></span>
      <span className="dot" style={{ backgroundColor: color, width: tamanho, height: tamanho }}></span>
      <span className="dot" style={{ backgroundColor: color, width: tamanho, height: tamanho }}></span>
    </div>
  );
};

export default LoadingPoints;
